import { useRef } from 'react';

// use if (isCancelError(e)) return; in catch
export const useAbortController = () => {
    const controller = useRef(new AbortController());

    const abortRequest = () => {
        controller.current?.abort();
        controller.current = new AbortController();
    };

    const getSignal = () => controller.current.signal;

    const isAbortError = (error) => {
        return (
            error?.message === 'canceled' ||
            error?.name === 'AbortError' ||
            error?.name === 'CanceledError'
        );
    };

    return { getSignal, abortRequest, isAbortError };
};
